import { isObject, inEnum, isNumber, isBoolean } from "@ciaopeople/cp-shatsu/TypeChecking";
import { CPNetworkName, isValidCPNetwork } from "./CPNetworks.js";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";

export enum MediaAutoplayPolicy {

    AUTOPLAY_ALWAYS = "always",
    AUTOPLAY_ONLY_IF_AUDIO_ON = "on_click",
    AUTOPLAY_IF_ADS_ARE_SERVABLE = "ifads_servable",
    NO_AUTOPLAY = "no"

}

export enum MediaAudioOnPolicy {
    ON_WHEN_AVAILABLE = 3, // #13960
    ON_IF_AVAILABLE_AT_START = 2,
    ON = 1,
    OFF = 0
}


export interface EmbeddablePlayerConfig  {
    autoplayPolicy: MediaAutoplayPolicy,
    volume?: number,
    loopPlaylist: boolean,
    withoutAdvertising?: boolean,
    css?: CPNetworkName,
    availableContent?: boolean

}

export function isEmbeddablePlayerConfig(obj: any): obj is EmbeddablePlayerConfig {

    return isObject(obj) &&
        hasOwnProperty(obj, 'autoplayPolicy') && inEnum(obj['autoplayPolicy'], MediaAutoplayPolicy) &&
        (!hasOwnProperty(obj, 'volume') || isNumber(obj['volume'])) &&
        hasOwnProperty(obj, 'loopPlaylist') && isBoolean(obj['loopPlaylist']) &&
        (!hasOwnProperty(obj, 'withoutAdvertising') || isBoolean(obj['withoutAdvertising'])) &&
        (!hasOwnProperty(obj, 'availableContent') || isBoolean(obj['availableContent'])) &&
        (!hasOwnProperty(obj, 'css') || isValidCPNetwork(obj['css']));
}
